/* istanbul ignore file */

import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ReadingDisplay = ({
  title,
  value,
  units,
  size,
  // make sure this is the RAAChanelKey (i.e. has sub id at the end)
  channelKey,
  isTriggered = null,
}) => {
  const {
    marginClass, titleFontSize, readingFontSize, subReadingFontSize, width,
  } = size === 'large' ? {
    marginClass: 'my-3',
    titleFontSize: '1.00rem',
    readingFontSize: '2.5rem',
    subReadingFontSize: '1.5rem',
    width: '60%',
  } : {
    marginClass: 'mt-0 mb-1',
    titleFontSize: '.75rem',
    readingFontSize: '1.75rem',
    subReadingFontSize: '1.00rem',
    width: '90px',
  };

  const {
    backgroundColor, readingTextColor,
  } = (() => {
    switch (isTriggered) {
      case null:
        return {
          backgroundColor: 'transparent', readingTextColor: '#000',
        };
      case true:
        return {
          backgroundColor: '#EE3524', readingTextColor: '#fff',
        };
      case false:
      default:
        return {
          backgroundColor: 'transparent', readingTextColor: '#000',
        };
    }
  })();

  const displayValue = !Number.isNaN(parseFloat(value))
    ? (
      <>
        <span style={{ fontSize: readingFontSize, fontWeight: 500 }}>
          {Math.floor(value)}
        </span>
        <span style={{ fontSize: subReadingFontSize }}>
          .
          {Math.abs(value % 1).toFixed(2).substring(2)}
          {units}
        </span>
      </>
    )
    : (
      <span style={{ fontSize: readingFontSize, fontWeight: 500 }} title={`${value}${units}`}>
        {value}
        {units}
      </span>
    );

  return (
    <a href={channelKey ? `/s/sensor-data/explore/${channelKey}` : '#'}>
      <Row className={`align-items-center ${marginClass}`} style={{ textAlign: 'center' }}>
        <Col>
          <h6 style={{
            margin: 0, color: 'black', fontWeight: 500, fontSize: titleFontSize,
          }}
          >
            {/* <span style={{ marginRight: '.25rem' }}> */}
            {/*  <AlertStatusIcon isTriggered={isTriggered} /> */}
            {/* </span> */}
            {title}
          </h6>
        </Col>
      </Row>
      <div
        className="text-nowrap"
        style={{
          backgroundColor, borderRadius: '10px', padding: '0', marginTop: '1.5rem', textAlign: 'center', color: readingTextColor, width, margin: '0 auto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}
      >
        {displayValue}
      </div>
    </a>
  );
};

ReadingDisplay.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  units: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  isTriggered: PropTypes.oneOf([true, false, null]),
  size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
  channelKey: PropTypes.string.isRequired,
};

export default ReadingDisplay;
